module.exports = __webpack_public_path__ + "static/media/logo-nsca-cpt2.a0a2ba79.png";